import { Navbar, Container, Image, Button, Nav, Dropdown } from 'react-bootstrap';
import { useNavigate, useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';
import logo from '../../assets/img/logo-conduto.png';
import './Navbar.css';

const CustomNavbar = ({ onToggleSidebar, username = "Usuario" }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [usuarioData, setUsuarioData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const cargarUsuario = () => {
      try {
        const usuarioStorage = localStorage.getItem('usuario');

        if (usuarioStorage) {
          const usuarioParsed = JSON.parse(usuarioStorage);
          setUsuarioData(usuarioParsed);
        }
      } catch (error) {
        console.error('Error parsing user data:', error);
      } finally {
        setLoading(false);
      }
    };

    cargarUsuario();
  }, []);

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('usuario');
    navigate('/administrador/login');
  };

  const isAdmin = () => {
    return usuarioData && usuarioData.rol === 'admin';
  };

  const getUsername = () => {
    if (usuarioData) {
      return usuarioData.nombre || usuarioData.usuario || "Usuario";
    }
    return username;
  };

  const isHojasVidaRoute = location.pathname === '/administrador/hojas-vida';
  const usuarioEsAdmin = isAdmin();

  if (loading) {
    return null;
  }

  return (
    <Navbar bg="white" variant="light" fixed="top" className="shadow-sm py-2 custom-navbar">
      <Container fluid>
        <div className="d-flex align-items-center">
          <Image
            src={logo}
            alt="Logo Empresa"
            height="16"
            width="auto"
            style={{ maxHeight: '36px', width: 'auto' }}
            className="d-inline-block align-top"
            fluid
          />
        </div>

        {usuarioEsAdmin && isHojasVidaRoute && (
          <Nav className="ms-auto d-flex align-items-center">
            <div className="d-none d-md-flex align-items-center">
              <span className="navbar-username me-3">
                <strong>{getUsername()}</strong>
              </span>
              <Button
                variant="outline-danger"
                size="sm"
                onClick={handleLogout}
                className="logout-btn"
              >
                <i className="bi bi-box-arrow-right me-1"></i>
                Cerrar Sesión
              </Button>
            </div>

            <Dropdown className="d-md-none">
              <Dropdown.Toggle
                variant="outline-secondary"
                size="sm"
                id="dropdown-user"
                className="user-dropdown-toggle"
              >
                <i className="bi bi-person-circle"></i>
              </Dropdown.Toggle>

              <Dropdown.Menu align="end">
                <Dropdown.Header>
                  {getUsername()}
                </Dropdown.Header>
                <Dropdown.Divider />
                <Dropdown.Item onClick={handleLogout} className="text-danger">
                  <i className="bi bi-box-arrow-right me-2"></i>
                  Cerrar Sesión
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </Nav>
        )}

        {(!usuarioEsAdmin || !isHojasVidaRoute) && (
          <div className="ms-auto">
          </div>
        )}
      </Container>
    </Navbar>
  );
};

export default CustomNavbar;